import styled from 'styled-components';

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 8px;
  color: ${(props) => props.theme.colors.white};

  .selected-trip {
    display: flex;
    flex-direction: column;
    gap: 2px;
    border-bottom: 1px solid ${(props) => props.theme.colors.outline};
    padding-bottom: 12px;
  }

  .primary {
    font-size: 13px;
    color: ${(props) => props.theme.colors.white};
  }

  .secondary {
    font-size: 12px;
    color: ${(props) => props.theme.colors.inactive};
  }

  .duration {
    color: ${(props) => props.theme.colors.orange};
  }

  .suggestion {
    font-size: 12px;
    color: ${(props) => props.theme.colors.main_cta};
  }

  .end-time {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .section-title {
      font-size: 13px;
      color: ${(props) => props.theme.colors.white};
    }

    .hint {
      font-size: 12px;
      color: ${(props) => props.theme.colors.inactive};
    }

    .selected-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
    }

    .selected-value {
      font-size: 13px;
      color: ${(props) => props.theme.colors.main_cta};

      &.empty {
        color: ${(props) => props.theme.colors.red};
      }
    }

    .use-now {
      flex-shrink: 0;

      p {
        font-size: 12px;
      }
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    border-top: 1px solid ${(props) => props.theme.colors.outline};
    padding-top: 16px;
  }

  .react-datepicker {
    border: none;
    background-color: ${(props) => props.theme.colors.widget_background};
    border-radius: 12px;
    padding: 10px;
    font-family: 'Noto Sans', sans-serif;

    .react-datepicker__header {
      background-color: ${(props) => props.theme.colors.widget_background};
      border-bottom: none;
    }

    .react-datepicker__current-month,
    .react-datepicker-time__header {
      color: ${(props) => props.theme.colors.white};
      margin-bottom: 5px;
    }

    .react-datepicker__day-name {
      color: ${(props) => props.theme.colors.inactive};
      width: 34px;
      height: 24px;
    }

    .react-datepicker__day {
      color: ${(props) => props.theme.colors.white};
      width: 34px;
      border-radius: 12px;

      &:hover {
        background: ${(props) => props.theme.colors.widget_hover_background};
      }

      &.react-datepicker__day--selected,
      &.react-datepicker__day--keyboard-selected {
        color: ${(props) => props.theme.colors.black};
        background: ${(props) => props.theme.colors.main_cta};
      }

      &.react-datepicker__day--disabled {
        color: ${(props) => props.theme.colors.outline};
      }
    }

    .react-datepicker__time-container {
      border-left: 1px solid ${(props) => props.theme.colors.outline};

      .react-datepicker__time,
      .react-datepicker__header--time {
        background: ${(props) => props.theme.colors.widget_background};
      }

      .react-datepicker__time-list-item {
        color: ${(props) => props.theme.colors.white};

        &:hover {
          background: ${(props) => props.theme.colors.widget_hover_background} !important;
        }

        &--selected {
          color: ${(props) => props.theme.colors.black} !important;
          background: ${(props) => props.theme.colors.main_cta} !important;
        }

        &--disabled {
          color: ${(props) => props.theme.colors.outline};
        }
      }
    }
  }
`;

export default { Form };
